
import React from "react";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaClock,
  FaTimesCircle,
  FaCreditCard,
} from "react-icons/fa";

const STATUS_CONFIG = {
  "Réglé": {
    label: "Réglé",
    Icon: FaCheckCircle,
    className:
      "bg-emerald-100 text-emerald-800 ring-emerald-300 dark:bg-emerald-900/40 dark:text-emerald-200 dark:ring-emerald-700",
  },

  "Partiellement réglé": {
    label: "Partiellement réglé",
    Icon: FaCreditCard,
    className:
      "bg-amber-100 text-amber-900 ring-amber-300 dark:bg-amber-900/40 dark:text-amber-200 dark:ring-amber-700",
  },

  "En cours": {
    label: "En cours",
    Icon: FaClock,
    className:
      "bg-blue-100 text-blue-800 ring-blue-300 dark:bg-blue-900/40 dark:text-blue-200 dark:ring-blue-700",
  },

  "Non réglé": {
    label: "Non réglé",
    Icon: FaExclamationCircle,
    className:
      "bg-red-100 text-red-800 ring-red-300 dark:bg-red-900/40 dark:text-red-200 dark:ring-red-700",
  },

  "Annulé": {
    label: "Annulé",
    Icon: FaTimesCircle,
    className:
      "bg-slate-200 text-slate-700 ring-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-600",
  },

  "Problème": {
    label: "Problème",
    Icon: FaExclamationCircle,
    className:
      "bg-rose-200 text-rose-900 ring-rose-400 dark:bg-rose-900/50 dark:text-rose-100 dark:ring-rose-700",
  },

  "Inexistant": {
    label: "Inexistant",
    Icon: FaExclamationCircle,
    className:
      "bg-red-600 text-white ring-red-700 dark:bg-red-700 dark:text-white dark:ring-red-500",
  },
};

export const REGLEMENT_OPTIONS = [
  "Réglé",
  "Partiellement réglé",
  "En cours",
  "Non réglé",
  "Annulé",
  "Problème",
  "Inexistant",
];

export const getReglementStatus = (value) => {
  const status = String(value || "").trim();

  if (!status) {
    return STATUS_CONFIG.Inexistant;
  }

  return (
    STATUS_CONFIG[status] || {
      label: status,
      Icon: FaExclamationCircle,
      className:
        "bg-slate-100 text-slate-700 ring-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-600",
    }
  );
};

export const reglementSorter = (a, b) => {
  const priority = {
    Inexistant: 0,
    Problème: 1,
    "Non réglé": 2,
    "Partiellement réglé": 3,
    "En cours": 4,
    Annulé: 5,
    Réglé: 6,
  };

  const statusA = a?.statut_reglement || "Inexistant";
  const statusB = b?.statut_reglement || "Inexistant";

  const rankA = priority[statusA] ?? 99;
  const rankB = priority[statusB] ?? 99;

  return (
    rankA - rankB ||
    String(a?.nom || "").localeCompare(
      String(b?.nom || ""),
      "fr",
      { sensitivity: "base" }
    ) ||
    String(a?.prenom || "").localeCompare(
      String(b?.prenom || ""),
      "fr",
      { sensitivity: "base" }
    )
  );
};

export default function ReglementStatusBadge({
  statut,
  compact = false,
  className = "",
}) {
  const config = getReglementStatus(statut);
  const Icon = config.Icon;

  return (
    <span
      title={`Règlement inscription : ${config.label}`}
      className={[
        "inline-flex max-w-full items-center justify-center gap-1.5",
        "rounded-lg font-bold ring-1",
        compact
          ? "px-2 py-1 text-[10px]"
          : "w-full px-3 py-2 text-xs",
        config.className,
        className,
      ].join(" ")}
    >
      <Icon className="shrink-0" />

      <span className="min-w-0 break-words">
        {config.label}
      </span>
    </span>
  );
}
